import React, { Component } from "react";
import { Link } from "react-router-dom";
import LatestRequestComponent from "./LatestRequestComponent";
import InternationalPopup from "./InternationalPopup";
import WhatsappOnboardingPopup from "./WhatsappOnboardingPopup";
import MobileUpdate from "../Dashboard/profile/MobileUpdate";
import AgentChatReport from "./AgentChatReport";
import LiveChatReport from "./LiveChatReport";
import MMLitePopup from "./MMLitePopup";
import ProTipChat from "./ProTipChat";
// import ExploreChat from "./ExploreChat";
import OnboardingStepper from "./OnboardingStepper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from 'axios';
import { FaWhatsapp } from "react-icons/fa";
import { HiSparkles } from "react-icons/hi";
import { MdPhoneInTalk } from 'react-icons/md';
import {
  faCompressAlt,
  faBriefcase,
  faBullhorn,
  faSms,
  faEnvelope,
  faWhatsapp,
  faSquareWhatsapp,
  faMicrophone,
  faBolt,
  faVoicemail,
} from "@fortawesome/free-solid-svg-icons";
import whatapp from "../Dashboard/assets/img/whatsapp.png";
import { HOST_URL, WhstappAccountList, userAPIReQuest, userProfile, whatsappSummery } from "./api/Api";
import ScoreCard from "../UI/Card/ScoreCard";
import Axios from "../../axios/Axios";
import { handleUserLog } from "../Utils/Utils";

class Home extends Component {
  constructor() {
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const parent_type = lStorage?.user?.parent_type;
    const reseller_id = lStorage?.user?.reseller_id;
    const sms_menu = lStorage.user.sms_menu === 0 ? false : true;
    const voice_menu = lStorage.user.voice_menu === 0 ? false : true;
    const email_menu = lStorage.user.email_menu === 0 ? false : true;
    const whatsapp_menu = lStorage.user.whatsapp_menu === 0 ? false : true;
    const authkey = lStorage.user.authkey_parent;
    const email = lStorage.user.username;
    const questioner = lStorage?.user?.questioner;
    var today = new Date(),
      date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        ("0" + today.getDate()).slice(-2);
    super();
    this.state = {
      user_id: userId,
      token: userToken,
      parent_type: parent_type,
      reseller_id: reseller_id,
      authkey,
      email,
      liveProfileToken: "",
      perMintCount: 0,
      ProfileName: "",
      currentDateTime: date,
      totalSMSSubmitted: 0,
      totalEmailSubmitted: 0,
      totalVoiceSubmitted: 0,
      totalWhatsappSubmitted: 0,
      expiryDate: "",
      expiryDaysLeft: "",
      userExpiredMesage: false,
      colorUpdate: "red",
      errorMessage: "",
      successMessage: false,
      bgColor: "alert alert-success alert-dismissible",
      smsMenu: sms_menu,
      voiceMenu: voice_menu,
      emailMenu: email_menu,
      whatsappMenu: whatsapp_menu,
      whatsappNumber: null,
      whatsappBrandNumber: null,
      showWhatsappOnboardingPopup: false,
      showOnboarding: false,
      questioner: questioner,

    };
  }

  calendlyLinks = {
    14: "https://calendly.com/ritu-datagenit/30min?utm_source=authkey&utm_medium=console&utm_campaign=Dashboard&utm_id=02",
    1779: "https://calendly.com/princejha8219/authkey-io-demo-or-discussion?utm_source=authkey&utm_medium=console&utm_campaign=Dashboard&utm_id=02"
  };


  handleClick = () => {
    const link = this.calendlyLinks[this.state.reseller_id];
    if (link) {
      window.open(link, "_blank");
    }
  };

  componentDidMount() {
    this.SmsSummery();
    this.voiceSummery();
    this.emialSummery();
    this.perMintHitCount();
    this.GetingProfile();
    this.getWhatsaAppNumberList();
    this.getWhatsappBrandNumber();

    let paramData = {
      user_id: this.state.user_id,
      method: "summary",
      token: this.state.token,
      date_from: this.state.currentDateTime,
      date_to: this.state.currentDateTime
    }

    whatsappSummery(paramData).then((res) => {
      this.setState({ totalWhatsappSubmitted: res.data.message.total });
    });

    const hostname = window.location.hostname;
    if (this.state.questioner === 0 && (hostname === "console.authkey.io" || hostname === "localhost")) {
      const stored = JSON.parse(localStorage.getItem("onboardingLastShown") || "{}");
      const now = Date.now();
      if (stored.userId !== this.state.user_id || now - stored.timestamp >= 24 * 60 * 60 * 1000) {
        localStorage.setItem("onboardingLastShown", JSON.stringify({ userId: this.state.user_id, timestamp: now }));
        this.setState({ showOnboarding: true });
      }
    }

  }

  perMintHitCount() {
    let paramData = {
      user_id: this.state.user_id,
      token: this.state.token,
      method: "summary"
    }
    userAPIReQuest(paramData).then((result) => {
      if (result.data.success === true) {
        this.setState({ perMintCount: result.data.message[0].cnt });
      } else {
        this.setState({ perMintCount: result.data.message });
      }
    });
  }

  SmsSummery = async () => {
    let paramData = {
      user_id: this.state.user_id,
      method: "summary",
      token: this.state.token,
      date_from: this.state.currentDateTime,
      date_to: this.state.currentDateTime,
    }
    let { data } = await Axios.post(`${HOST_URL}/sms_report.php`, paramData);
    if (data.success === true) {
      this.setState({
        totalSMSSubmitted: data.message.total,
        colorUpdate: this.state.colorUpdate === "red" ? "#3F3966" : "red",
      });
    } else {
      this.setState({ totalSMSSubmitted: data.message });
    }
  }

  voiceSummery = async () => {
    let paramData = {
      user_id: this.state.user_id,
      method: "summary",
      token: this.state.token,
      date_from: this.state.currentDateTime,
      date_to: this.state.currentDateTime,
    }
    let { data } = await Axios.post(`${HOST_URL}/voice_report.php`, paramData);
    if (data.success === true) {
      this.setState({
        totalVoiceSubmitted: data.message.total,
        colorUpdate: this.state.colorUpdate === "red" ? "#3F3966" : "red",
      });
    } else {
      this.setState({ totalVoiceSubmitted: data.message });
    }
  }

  emialSummery = async () => {
    let paramData = {
      user_id: this.state.user_id,
      method: "summary",
      token: this.state.token,
      date_from: this.state.currentDateTime,
      date_to: this.state.currentDateTime,
    }
    let { data } = await Axios.post(`${HOST_URL}/email_report.php`, paramData);
    if (data.success === true) {
      this.setState({
        totalEmailSubmitted: data.message.total,
        colorUpdate: this.state.colorUpdate === "red" ? "#3F3966" : "red",
      });
    } else {
      this.setState({ totalEmailSubmitted: data.message });
    }
  }

  GetingProfile() {
    let paramData = {
      user_id: this.state.user_id,
      token: this.state.token,
      method: "retrieve"
    }
    userProfile(paramData).then((result) => {
      if (result.data.success === true) {
        this.setState({
          ProfileName: result.data.data[0].username,
          liveProfileToken: result.data.data[0].token,
        });
        this.forceUpdate();
        this.getuserExpiry(result.data.data[0].expiry);
      }
      if (result.message === "Invalid Token") {
        this.universalLogout();
      }
    });
  }

  universalLogout() {
    window.location = "/logout";
  }

  getuserExpiry(e) {
    const userDate = new Date(e).toISOString().slice(0, 10);
    const TodateDate = new Date().toISOString().slice(0, 10);
    if (userDate < TodateDate) {
      this.setState({ userExpiredMesage: true, expiryDaysLeft: 0 });
      setTimeout(function () {
        localStorage.clear();
        window.location = "/";
      }, 2000);
    } else {
      const userDate = new Date(e);
      const TodateDate = new Date();
      const diffTime = Math.abs(TodateDate - userDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      //console.log('expiryDate',diffDays);
      if (diffDays <= 10) {
        this.setState({ userExpiredMesage: true, expiryDaysLeft: diffDays });
      } else {
        this.setState({ userExpiredMesage: false, expiryDaysLeft: userDate });
      }
    }
  }

  getWhatsappBrandNumber = async () => {
    this.setState({ loadingWhatsappNumber: true, whatsappError: "" });

    try {
      const lStorage = JSON.parse(localStorage.getItem("login"));
      const userId = lStorage.user.userId;
      const userToken = lStorage.token;

      const response = await Axios.post(
        "https://console.authkey.io/api/wp_profile.php",
        {
          user_id: userId,
          token: userToken,
          method: "retrieve",
        }
      );

      if (response.data.success === true && response.data.data?.length > 0) {
        const number = response.data.data[0].brand_number || null;
        this.setState({ whatsappBrandNumber: number, loadingWhatsappNumber: false });
      } else {
        this.setState({ whatsappBrandNumber: null, whatsappError: "Brand number not found.", loadingWhatsappNumber: false });
      }
    } catch (err) {
      this.setState({ whatsappBrandNumber: null, whatsappError: "Error fetching WhatsApp number.", loadingWhatsappNumber: false });
    }
  };

  handlewhatsapp = async () => {
    try {
      // const lStorage = JSON.parse(localStorage.getItem("login"));
      // const email = lStorage.user.username;

      // console.log("Email from localStorage:", email);

      // if (!email) {
      //   console.error("Missing email");
      //   return;
      // }

      const response = await axios.get("https://console.authkey.io/api/wp_profile.php", {
        params: {
          user_id: this.state.user_id,
          token: this.state.token,
          method: "send_helpdocs_email",
        },
      });

      console.log("API Response:", response.data);
    } catch (error) {
      console.error("WhatsApp onboarding API error:", error.message || error);
    } finally {
      if (this.state.whatsappNumber?.status === 0) {
        window.location = `/dashboard/whatsapp/edit/${this.state.whatsappNumber?.id}`
      }
      else {
        window.location = "/dashboard/whatsapp-onboarding-new";
      }
    }
  };



  getWhatsaAppNumberList = async () => {
    let paramData = {
      user_id: this.state.user_id,
      token: this.state.token,
      method: "retrieve",
    }
    WhstappAccountList(paramData).then((res) => {
      if (res.data.success === true) {
        this.setState({ whatsappNumber: res.data.data[0], setIsLoading: false });
      } else {
        this.setState({ ErrorResponse: res.data, setIsLoading: false });
      }
    })
  };

  goToAgentDashboardFromProTip = () => {
    const lStorage = JSON.parse(localStorage.getItem("login"));
    if (!lStorage || !this.state.whatsappBrandNumber) return;

    const { token, user } = lStorage;

    const userData = {
      data: {
        permission: '{ "add": 1, "update": 1, "delete": 1 }',
        success: true,
        user_type: "admin",
        brand_number: this.state.whatsappBrandNumber,
        user_id: user.userId,
        parent_id: user.userId,
        parent_token: token,
        name: user.name,
        email: user.username,
        token: token,
        mobile: user.mobile,
        authkey_parent: user.authkey_parent,
      },
    };

    const encodedUserData = encodeURIComponent(JSON.stringify(userData));

    const savedDomain = localStorage.getItem("wp-cmpy-domain");
    const hostname = window.location.hostname;

    const domain =
      savedDomain ||
      (hostname.split(".").length <= 2
        ? hostname
        : hostname.split(".").slice(-2).join("."));

    window.open(`https://agent.${domain}/?user=${encodedUserData}`, "_blank");
  };

  handleOnboardingFinish = () => {
    localStorage.removeItem("onboardingLastShown");
    this.setState({ showOnboarding: false });
  };

  // Called when user clicks × — only dismisses for this session
  handleOnboardingClose = () => {
    this.setState({ showOnboarding: false });
  };

  render() {
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const userMobile = lStorage ? lStorage.user.mobile : null;
    const allowedDomains = ["console.authkey.io", "localhost:3000"];
    const currentDomain = window.location.host;
    const showHelpButton = allowedDomains.includes(currentDomain) && this.state.parent_type === "emp" &&
      (this.state.reseller_id === 14 || this.state.reseller_id === 1779);

    // const lastUpdateShown = localStorage.getItem("lastMobileUpdateTimestamp");
    // const currentTime = Date.now();
    // const timeDiff = lastUpdateShown ? currentTime - lastUpdateShown : null;
    // const showMobileUpdate = !userMobile && (!lastUpdateShown || timeDiff >= 24 * 60 * 60 * 1000);

    // if (showMobileUpdate) {
    //   localStorage.setItem("lastMobileUpdateTimestamp", currentTime);
    // }


    return (
      <main className="content">

        {this.state.showOnboarding && (
  <div className="onboarding-overlay">
    <OnboardingStepper
      onFinish={this.handleOnboardingFinish}
      onClose={this.handleOnboardingClose}
    />
  </div>
)}

        <div className="container-fluid p-0">
          <ProTipChat onClick={this.goToAgentDashboardFromProTip} />
          <div className="row">
            <div className="col-12 mb-1">
              <div className="d-flex  flex-column flex-md-row justify-content-between">
                <div>
                  <span style={{ color: "#3F3966", fontSize: 18, fontWeight: 700 }}>
                    {" "}
                    Welcome : {this.state.ProfileName}{" "}
                  </span>


                  {this.state.userExpiredMesage ? (
                    <span className="badge badge-danger">
                      {" "}
                      Your Account Will expire within{" "}
                      <span>{this.state.expiryDaysLeft}</span> Days{" "}
                    </span>
                  ) : null}
                </div>
                <div className="d-flex flex-wrap gap-2 justify-content-end ms-md-3 mt-2 mt-md-0">
                  {showHelpButton && (
                    <button
                      type="button"
                      className="btn btn-info d-flex align-items-center mb-2"
                      onClick={this.handleClick}
                      style={{
                        padding: '9px 16px',
                        fontSize: '0.92rem',
                        lineHeight: 1.2
                      }}
                    >
                      <MdPhoneInTalk className="me-2 ringing-phone-icon" size={18} />
                      Book a Call with Expert
                    </button>
                  )}

                  {this.state.whatsappMenu === true && (
                      <button
                        type="button"
                        className="btn btn-success d-flex align-items-center mb-2"
                        // onClick={this.handlewhatsapp}
                        onClick={() => {
                          handleUserLog("" ,"whatsapp_onboarding", "whatsapp_onboarding", "whatsapp onboarding button click", "dashboard", "" , "");
                          this.setState({ showWhatsappOnboardingPopup: true });
                        }}
                        style={{
                          padding: '9px 16px',
                          fontSize: '0.92rem',
                          lineHeight: 1.2
                        }}
                      >
                        <FaWhatsapp className="me-2" size={18} />
                        WhatsApp Onboarding
                      </button>
                    )}
                </div>
              </div>

            </div>
          </div>

          <InternationalPopup />
          <MMLitePopup />
          <WhatsappOnboardingPopup
            open={this.state.showWhatsappOnboardingPopup}
            onClose={() => this.setState({ showWhatsappOnboardingPopup: false })}
            onProceed={() => {
              // close popup and redirect to onboarding page
              this.setState({ showWhatsappOnboardingPopup: false }, () => {
                window.location = "/dashboard/whatsapp-onboarding-new";
              });
            }}
          />

          {!userMobile && !this.state.showOnboarding && <MobileUpdate />}
          <div className="row">
            <div className="card">
              <div className="col-xl-12 col-xxl-5 d-flex">
                <div className="w-100">
                  <div className="row">
                    <div className="col-auto mt-2 d-none d-sm-block">
                      <h3>
                        <strong>Today's</strong> Report{" "}
                      </h3>
                    </div>
                  </div>
                  <div className="score-card">
                    {this.state.smsMenu && (
                      <div className="box">
                        <ScoreCard
                          title={` SMS`}
                          icon={faSms}
                          type="icon"
                          value={this.state.totalSMSSubmitted}
                        />
                      </div>
                    )}
                    {this.state.emailMenu && (
                      <div className="box">
                        <ScoreCard
                          title={` Email`}
                          icon={faEnvelope}
                          type="icon"
                          value={this.state.totalEmailSubmitted}
                        />
                      </div>
                    )}
                    {this.state.voiceMenu && (
                      <div className="box">
                        <ScoreCard
                          title={` Voice`}
                          icon={faMicrophone}
                          type="icon"
                          value={this.state.totalVoiceSubmitted}
                        />
                      </div>
                    )}
                    {this.state.whatsappMenu && (
                      <div className="box">
                        <ScoreCard
                          title={` WhatsApp`}
                          icon={whatapp}
                          type="img"
                          value={
                            this.state.totalWhatsappSubmitted
                              ? this.state.totalWhatsappSubmitted
                              : 0
                          }
                        />
                      </div>
                    )}
                    {(
                      <div className="box">
                        <ScoreCard
                          title={`Request / Min.`}
                          type="icon"
                          icon={faBolt}
                          value={this.state.perMintCount}
                        />
                      </div>
                    )}

                  </div>


                  {this.state.whatsappMenu && this.state.whatsappBrandNumber && (
                    <div className="row">
                      <div className="col-12 col-md-4 mb-3 mb-md-0">
                        <AgentChatReport />
                      </div>
                      <div className="col-12 col-md-8">
                        <LiveChatReport />
                      </div>
                    </div>
                  )}


                  {(this.state.smsMenu ||
                    this.state.voiceMenu ||
                    this.state.emailMenu) && (
                      <div className="row">
                        <div className="col-auto d-none d-sm-block">
                          <h3>
                            <strong>Quick</strong> links
                          </h3>
                        </div>
                      </div>
                    )}

                  <div className="row">
                    {this.state.smsMenu && (
                      <div className="col-sm-3">
                        <div className="card">
                          <div className="card-body ">
                            <div className="">
                              <span className="text-danger">
                                {" "}
                                <FontAwesomeIcon icon={faSms} />{" "}
                              </span>
                              <Link to="/dashboard/whatsapp-widget">
                                {" "}
                                <span className="text-muted font-weight-bold text-right">
                                  WhatsApp Widget
                                </span>{" "}
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {this.state.emailMenu && (
                      <div className="col-sm-3">
                        <div className="card">
                          <div className="card-body">
                            <div className="">
                              <span className="text-danger">
                                {" "}
                                <FontAwesomeIcon icon={faBullhorn} />{" "}
                              </span>
                              <Link to="/dashboard/apply-rcs">
                                {" "}
                                <span className="text-muted font-weight-bold text-right">
                                  RCS Onboarding
                                </span>{" "}
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {this.state.voiceMenu && (
                      <div className="col-sm-3">
                        <div className="card">
                          <div className="card-body">
                            <div className="">
                              <span className="text-danger">
                                {" "}
                                <FontAwesomeIcon icon={faBriefcase} />{" "}
                              </span>
                              <Link to="/dashboard/api-docs">
                                {" "}
                                <span className="text-muted font-weight-bold text-right">
                                  API Docs
                                </span>{" "}
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {this.state.smsMenu && (
                      <div className="col-sm-3">
                        <div className="card">
                          <div className="card-body">
                            <div className="">
                              <span className="text-danger">
                                <FontAwesomeIcon icon={faCompressAlt} />{" "}
                              </span>
                              <Link to="/dashboard/create-sender-id">
                                {" "}
                                <span className="text-muted font-weight-bold text-right">
                                  DLT Setup
                                </span>{" "}
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <LatestRequestComponent />
        </div>
        {/* <ExploreChat /> */}
      </main>
    );
  }
}
export default Home;
